<div class="layout-container" [class.is-mobile]="isMobileOrTablet">

  @if (isMobileOrTablet) {
  <header class="mobile-header" role="banner">
    <button class="menu-toggle" type="button" (click)="toggleSidebar()" title="Menu" aria-label="Abrir menu de navegação">
      <i class="bi bi-list" aria-hidden="true"></i>
    </button>
    <div class="mobile-brand">
      <i class="bi bi-truck" aria-hidden="true"></i>
      <span>Logística</span>
    </div>
    <div class="spacer"></div>
    @if (showMobileBackButton()) {
    <button class="mobile-back" type="button" (click)="goBackFromMobileHeader()" title="Voltar" aria-label="Voltar para tela anterior">
      <i class="bi bi-arrow-left" aria-hidden="true"></i>
    </button>
    }
  </header>

  <!-- Overlay for mobile sidebar -->
  @if (isSidebarExpanded) {
  <div class="sidebar-overlay" (click)="closeSidebar()"></div>
  }
  }

  <app-sidebar class="sidebar" (click)="closeSidebar()" (toggleProfileModalEvent)="showProfileModal.set(true)" />

  <main id="main-content" class="main-content" role="main" tabindex="-1">
    <div class="page-container">
      <router-outlet />
    </div>
  </main>
</div>

@if (showProfileModal()) {
<app-modal [open]="true" (closeModal)="showProfileModal.set(false)" title="Perfil do Usuário" icon="bi-person-badge"
  maxWidth="450px">
  <div body class="profile-modal-content">
    <div class="profile-card">
      <div class="profile-avatar-wrapper">
        <div class="profile-avatar-large">
          <i class="bi bi-person-circle" aria-hidden="true"></i>
        </div>
        <app-badge [label]="usuarioCompleto()?.administrador ? 'Administrador' : 'Colaborador'" 
          [type]="usuarioCompleto()?.administrador ? 'primary' : 'secondary'" class="profile-badge" />
      </div>

      <div class="profile-main-info">
        <h3 class="profile-name">{{ usuarioCompleto()?.nome || 'Usuário' }}</h3>
        <p class="profile-email">{{ usuarioCompleto()?.email || 'E-mail não disponível' }}</p>
      </div>

      <div class="data-grid profile-info-grid">
        <div class="data-item">
          <span class="d-label">CPF</span>
          <span class="d-value">
            <i class="bi bi-card-text me-2" aria-hidden="true"></i>
            {{ usuarioCompleto()?.cpf || '-' }}
          </span>
        </div>
        <div class="data-item">
          <span class="d-label">Status da Conta</span>
          <span class="d-value">
            <app-badge [label]="usuarioCompleto()?.ativo ? 'Ativa' : 'Inativa'" 
              [type]="usuarioCompleto()?.ativo ? 'success' : 'danger'" />
          </span>
        </div>
        <div class="data-item">
          <span class="d-label">Membro desde</span>
          <span class="d-value">
            <i class="bi bi-calendar3 me-2" aria-hidden="true"></i>
            {{ (usuarioCompleto()?.data_criacao | date:'dd/MM/yyyy') || '-' }}
          </span>
        </div>
      </div>

      <div class="version-info">
        <div class="version-label">
          <i class="bi bi-info-circle me-1" aria-hidden="true"></i>
          Versão do Sistema
        </div>
        <div class="version-value">{{ appVersion }}</div>
      </div>
    </div>
  </div>

  <div footer>
    <app-button label="Sair da Conta" class="btn danger ghost" icon="bi-box-arrow-right" (click)="logout()" />
  </div>
</app-modal>
}
